export const removeAllTemplatesMutation = `
  mutation Mutation {
    shopRemoveAllTemplates
  }
`
